import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  title: 'Autore antico',
  tabs: 'ancient_author',
  type: 'ancient_author',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'tab-bar',
        type: 'tabs'
      }
    ],
    content: [
      {
        id: 'metadata-works',
        type: 'metadata',
        title: 'resource#metadata',
      },
    ],
  },
} as ConfigMurucaResourceLayout;
